<template>
  <v-col class="pa-0">
    <v-row class="ma-0 pa-0">
      <v-col align="center" cols="8" offset="2">
        <h2>{{ $translate('RESET_PASS_TITLE') }}</h2>
      </v-col>
      <v-col class="text-right">
        <v-icon
          size="20"
          @click="$emit('triggerPopup', { toggle: false, component: 'Login' })"
        >
          ti-close
        </v-icon>
      </v-col>
    </v-row>
    <v-col class="py-0">
      <p class="text-center">{{ $translate('RESET_PASS_SUBTITLE') }}</p>
    </v-col>
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-row class="mx-3">
        <v-col cols="12" class="pt-1 pb-0">
          <v-text-field
            v-model="email"
            :rules="emailRules"
            :label="$translate('EMAIL')"
            outlined
            required
          />
        </v-col>
        <v-col cols="12">
          <v-alert
            v-if="errorMessage !== ''"
            color="red"
            dense
            text
            type="error"
            >{{ errorMessage }}</v-alert
          >
          <v-btn
            color="primary"
            depressed
            block
            large
            class="pt-1 primary-font-color"
            @click="resetPassword"
            :loading="loading"
          >
            {{ $translate('INCIDENT_SEND') }}
          </v-btn>
        </v-col>
        <v-divider />
      </v-row>
    </v-form>
    <v-card flat color="#d9d9d9" class="mt-3">
      <v-row class="mx-3 my-0 pa-4" align="center" justify="center">
        <v-col align="center" justify="center" class="pa-0">
          <v-btn
            color="primary"
            class="primary-font-color"
            depressed
            large
            @click="onLoginBtnClick"
          >
            {{ $translate('LOGIN') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
import doRequest from '@/api/dssRequest';

export default {
  name: 'AccountResetPassword',
  props: {
    initialEmail: String,
  },
  data() {
    return {
      email: '',
      emailRules: [
        (v) => !!v || this.$translate('EMAIL_REQUIRED'),
        (v) => /.+@.+\..+/.test(v) || this.$translate('EMAIL_VALID'),
      ],
      loading: false,
      valid: null,
      errorMessage: '',
    };
  },
  mounted() {
    if (this.initialEmail != null) {
      this.email = this.initialEmail;
    }
  },
  computed: {},
  methods: {
    resetPassword() {
      // Request an email with a link to reset the password
      if (this.$refs.form.validate()) {
        this.loading = true;
        const payload = {
          Email: this.email,
        };
        doRequest(
          () => {
            // On response
            this.loading = false;
            this.$emit('triggerPopup', {
              toggle: true,
              component: 'ResetPasswordSuccess',
            });
          },
          (error) => {
            // On error
            this.loading = false;
            this.errorMessage = this.$translateError(error.data.ErrorCode);
          },
          'resetPassword',
          `${this.$store.getters['Account/partnerGroupDetails'].AccountId}_UM`,
          payload
        );
      } else {
        window.EventBus.fire('activateSnackBar', {
          text: this.$translate('LINDA_FILL_REQUIRED'),
          color: 'warning',
        });
      }
    },
    onLoginBtnClick() {
      this.$emit('triggerPopup', {
        toggle: true,
        component: 'Login',
        props: {
          initialEmail: this.email,
        },
      });
    },
  },
};
</script>
